import { render, staticRenderFns } from "./customerInput.vue?vue&type=template&id=b0d9a6c6&scoped=true"
import script from "./customerInput.vue?vue&type=script&lang=js"
export * from "./customerInput.vue?vue&type=script&lang=js"
import style0 from "./customerInput.vue?vue&type=style&index=0&id=b0d9a6c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0d9a6c6",
  null
  
)

export default component.exports